const KpssCompatibilityStatus =   {
    None : 0,
    Compatible : 1,
    NotCompatible : 2
};


export default KpssCompatibilityStatus;